import { render } from "./MetadataInput.vue?vue&type=template&id=7867e00e&scoped=true&ts=true"
import script from "./MetadataInput.vue?vue&type=script&lang=ts"
export * from "./MetadataInput.vue?vue&type=script&lang=ts"

import "./MetadataInput.vue?vue&type=style&index=0&id=7867e00e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7867e00e"]])

export default __exports__